import { Component, Inject, ViewEncapsulation, OnInit, AfterViewInit } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup } from '@angular/forms';
import dayjs from 'dayjs';

@Component({
// tslint:disable-next-line: component-selector
	selector: 'tr2-inputbs',
	templateUrl: 'inputbs.component.html',
	styleUrls: ['inputbs.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class InputBS implements OnInit, AfterViewInit {
	inicializado = false;
	inputbsForm: FormGroup;
	formControlName = '';
	placeholder = 'Ingrese un valor';
	clase = 'full-width';
	hint = '';
	rows = 2;

	touchUi = false;
	openIcon = 'event';
	prefixes = [];
	suffixes = [];
	onInputPopup = false;
	buscaExtra = null;

	resultados = [];
	busca = '';
	min = 1;
	boton = '';
	clickBoton = new Function();
	cambiaChip = new Function();
	chips = false;
	private _required = false;

	fechasResaltadas = (d: dayjs.Dayjs) => false;
	Filter = () => true;
	/** Variable que indica si el campo es requerido para el formulario */
	get required(): boolean {
		if (this._required) {
			return this._required;
		}
		// cuando el control retorna un error desde la validación con un valor vacío
		if (this.inputbsForm.get(this.formControlName) && this.inputbsForm.get(this.formControlName).validator) {
			const emptyValueControl = Object.assign({}, this.inputbsForm.get(this.formControlName));
			(emptyValueControl as any).value = null;
			return 'required' in (this.inputbsForm.get(this.formControlName).validator(emptyValueControl) || {});
		}
		return false;
	}

	constructor(
		@Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
		private elementRef: MatBottomSheetRef<InputBS>
	) {
		if (!data.tipo) {
			data.tipo = 'input';
		}
		if (!data.placeholder) {
			data.placeholder = 'Ingrese un valor';
		}
		this.inputbsForm = data.form;
		this.formControlName = data.formControlName;
		this.placeholder = data.placeholder;
		this.clase = (data.clase) ? data.clase : this.clase;
		this.hint = (data.hint) ? data.hint : this.hint;
		this.rows = (data.rows) ? data.rows : this.rows;

		this.Filter = (data.Filter) ? data.Filter : this.Filter;
		this.touchUi = (data.touchUi) ? data.touchUi : this.touchUi;
		this.openIcon = (data.openIcon) ? data.openIcon : this.openIcon;
		this.prefixes = (data.prefixes) ? data.prefixes : this.prefixes;
		this.suffixes = (data.suffixes) ? data.suffixes : this.suffixes;
		this.fechasResaltadas = (data.fechasResaltadas) ? data.fechasResaltadas : this.fechasResaltadas;
		this.onInputPopup = (data.onInputPopup) ? data.onInputPopup : this.onInputPopup;

		this.resultados = (data.resultados) ? data.resultados : this.resultados;
		this.busca = (data.busca) ? data.busca : this.busca;
		this.min = (data.min) ? data.min : this.min;
		this.boton = (data.boton) ? data.boton : this.boton;
		this.clickBoton = (data.clickBoton) ? data.clickBoton : this.clickBoton;
		this.cambiaChip = (data.cambiaChip) ? data.cambiaChip : this.cambiaChip;
		this.chips = (data.chips) ? data.chips : this.chips;
		this.buscaExtra = (data.buscaExtra) ? data.buscaExtra : this.buscaExtra;
	}

	ngOnInit() {
		this.inicializado = true;
	}

	ngAfterViewInit() {
		return;
	}

	cerrar(value?: any): void {
		this.elementRef.dismiss(this.data);
	}

	onFocus(event) {
		if (event.target.select) {
			event.target.select();
		}
	}
}
